"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditPurchaseStatus = exports.TimeEntryType = exports.TalentManagerEngagementStatus = exports.TalentManagerApprovalStatus = void 0;
var TalentManagerApprovalStatus;
(function (TalentManagerApprovalStatus) {
    TalentManagerApprovalStatus["PENDING"] = "pending";
    TalentManagerApprovalStatus["APPROVED"] = "approved";
    TalentManagerApprovalStatus["SUSPENDED"] = "suspended";
})(TalentManagerApprovalStatus || (exports.TalentManagerApprovalStatus = TalentManagerApprovalStatus = {}));
var TalentManagerEngagementStatus;
(function (TalentManagerEngagementStatus) {
    TalentManagerEngagementStatus["ACTIVE"] = "active";
    TalentManagerEngagementStatus["PAUSED"] = "paused";
    TalentManagerEngagementStatus["COMPLETED"] = "completed";
    TalentManagerEngagementStatus["CANCELLED"] = "cancelled";
})(TalentManagerEngagementStatus || (exports.TalentManagerEngagementStatus = TalentManagerEngagementStatus = {}));
var TimeEntryType;
(function (TimeEntryType) {
    TimeEntryType["CHAT_AUTO"] = "chatAuto";
    TimeEntryType["MANUAL"] = "manual";
})(TimeEntryType || (exports.TimeEntryType = TimeEntryType = {}));
var CreditPurchaseStatus;
(function (CreditPurchaseStatus) {
    CreditPurchaseStatus["PENDING"] = "pending";
    CreditPurchaseStatus["COMPLETED"] = "completed";
    CreditPurchaseStatus["REFUNDED"] = "refunded";
})(CreditPurchaseStatus || (exports.CreditPurchaseStatus = CreditPurchaseStatus = {}));
//# sourceMappingURL=talent-manager-types.js.map